var map = {
	"./cupis/bg-happy_hockey-mobile.jpg": "BM2B",
	"./cupis/bg-happy_hockey.jpg": "YsM1",
	"./cupis/bg-start15or20-mobile.jpg": "Cdqa",
	"./cupis/bg-start15or20.jpg": "Fv+D",
	"./zenbet/bg-happy_hockey-mobile.jpg": "Kly5",
	"./zenbet/bg-happy_hockey.jpg": "3S/W",
	"./zenit/bg-happy_hockey-mobile.jpg": "VnW3",
	"./zenit/bg-happy_hockey.jpg": "OSJT"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zuPF";